import {Subscription} from 'rxjs';
import {signal, TemplateRef, WritableSignal} from '@angular/core';
import {MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {DialogDirective} from './lib/directives/dialog.directive';

export type IDialogConfig<T> = MatDialogConfig<T> & {};

export class DialogModel<T = any> {
	id: string;
	data$: Signal<T> = signal(undefined);

	dialogDirective: DialogDirective;
	contextElement: TemplateRef<any>;
	subscriptions: Subscription[] = [];

	matDialogRef: MatDialogRef<T>;
	dialogConfig: IDialogConfig<T>;

	state$: WritableSignal<'new' | 'open' | 'close'> = signal('new');

	constructor(id: string, dialogDirective: DialogDirective, contextElement: TemplateRef<any>, config: IDialogConfig<T>) {
		this.id = id;
		this.dialogDirective = dialogDirective;
		this.contextElement = contextElement;
		this.dialogConfig = new MatDialogConfig<T>();
		this.applyConfigs(config);
	}

	public applyConfigs(config: IDialogConfig<T>) {
		if (config) {
			Object.entries(config).forEach(([key, value]) => {
				if (value === undefined) delete config[key];
			});
			Object.assign(this.dialogConfig, config);
		}
	}
}
